module.exports = __webpack_public_path__ + "img/context_icon_hover.66d55466.svg";